import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteGroupcardMemberApi, getAllCardDetail, getAllCardInfo, getCardGetCardForExistingEducation, getCardsForExistingExperiences, getFamilyApi, getNoOfCardCount, getVisitingCard, postAttachDocs, postCardProfileLogoApi, postCreateCardFromExistingEducation, postCreateCardFromOldExperience, postCreateCardWithNewEducation, postCreateCardWithNewExperience, updateProfessionalCardApi, updateStudentCardApi } from "../helpers/CardHelperApis";
// import { act } from "react";


const initialState = {
    AllCardDetailsInfo: [],
    AllCardsInfo: [],
    NoOfCardCount: {},
    visitingCard: {},
    AttachDocs: {},
    cardProfileLogo: {},
    groupcard: {},
}

export const getAllCardDetailsReducer = createAsyncThunk('/AllCardDetails', async (_, thunkAPI) => {
    try {
        const response = await getAllCardDetail();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
}
);

export const getAllCardInfoReducer = createAsyncThunk('/AllcardInfo', async (_, thunkAPI) => {
    try {
        const response = await getAllCardInfo();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getFamilyCardReducer = createAsyncThunk('/Groupcard', async (id, thunkAPI) => {
    try {
        const response = await getFamilyApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getNoOfCardCountReducer = createAsyncThunk('/Allcardcount', async (_, thunkAPI) => {
    try {
        const response = await getNoOfCardCount();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


export const getVisitingCardReducer = createAsyncThunk('/visitingCard/get', async ({ encryptedId }, thunkAPI) => {
    try {
        const response = await getVisitingCard({ encryptedId }, thunkAPI);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});
export const postAttachDocsReducer = createAsyncThunk('/postAttachDocs', async (formData, thunkAPI) => {
    try {
        const response = await postAttachDocs(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postCardProfileLogoReducer = createAsyncThunk('/postCardProfileLogo', async (formData, thunkAPI) => {
    try {
        const response = await postCardProfileLogoApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const deleteGroupcardMemberReducer = createAsyncThunk('/deleteFamilycardMember', async (data, thunkAPI) => {
    try {
        const response = await deleteGroupcardMemberApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


export const postCreateCardFromOldExperienceReducer = createAsyncThunk("/cretecardfromoldexperience", async (formData, thunkAPI) => {
    try {
        const response = await postCreateCardFromOldExperience(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const postCreateCardWithNewExperienceReducer = createAsyncThunk("/postCreateCardWithNewExperience", async (formData, thunkAPI) => {

    try {
        const response = await postCreateCardWithNewExperience(formData);
        return response;
    } catch (error) {

        return thunkAPI.rejectWithValue(error.message);
    }
});


export const getCardGetCardForExistingEducationReducer = createAsyncThunk("/getCardGetCardForExistingEducation", async (id, thunkAPI) => {

    try {
        const response = await getCardGetCardForExistingEducation(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


export const getCardsForExistingExperiencesReducer = createAsyncThunk("/getCardsForExistingExperiences", async (id, thunkAPI) => {

    try {
        const response = await getCardsForExistingExperiences(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


export const postCreateCardWithNewEducationReducer = createAsyncThunk("/postCreateCardWithNewEducation", async (formData, thunkAPI) => {

    try {
        const response = await postCreateCardWithNewEducation(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const postCreateCardFromExistingEducationReducer = createAsyncThunk("/postCreateCardFromExistingEducation", async (formData, thunkAPI) => {

    try {
        const response = await postCreateCardFromExistingEducation(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const patchProfessionalCardReducer = createAsyncThunk("/updateProfessionalCard", async ({ id, data }, thunkAPI) => {

    try {
        const response = await updateProfessionalCardApi(id, data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const patchStudentCardReducer = createAsyncThunk("/updateStudentcard", async ({ id, data }, thunkAPI) => {

    try {
        const response = await updateStudentCardApi(id, data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});
const cardSlice = createSlice({
    name: 'cardsData',
    initialState,
    reducers: {
        clearCardDataState: (state) => {
            state.AllCardDetailsInfo = [];
            state.AllCardsInfo = [];
            state.NoOfCardCount = {};
            state.visitingCard = {};
        },
        clearGroupcarddata: (state) => {
            state.groupcard = {}
        }

    },
    extraReducers: (builder) => {
        builder.addCase(getAllCardDetailsReducer.fulfilled, (state, action) => {
            // console.log("getAllCardDetails ", JSON.stringify(action));
            state.AllCardDetailsInfo = action.payload;
        })
            .addCase(getAllCardDetailsReducer.rejected, (state, action) => {
                console.log("Error Details", action.error.message);
            })

        builder.addCase(getAllCardInfoReducer.fulfilled, (state, action) => {
            // console.log('getAllCardInfoReducer', JSON.stringify(action));
            state.AllCardsInfo = action.payload;
        }).addCase(getAllCardInfoReducer.rejected, (state, action) => {
            console.log("Error Details", action.error.message);
        })
        builder.addCase(getNoOfCardCountReducer.fulfilled, (state, action) => {
            // console.log("getNoOfCardCountReducer", JSON.stringify(action));
            state.NoOfCardCount = action.payload.data;
        }).addCase(getNoOfCardCountReducer.rejected, (state, action) => {
            console.log("Error Details", action.error.message);
        })
        builder
            .addCase(getVisitingCardReducer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getVisitingCardReducer.fulfilled, (state, action) => {
                state.loading = false;
                // console.log("get Visiting CardReducer", JSON.stringify(action));
                state.visitingCard = action.payload.data;
            })
            .addCase(getVisitingCardReducer.rejected, (state, action) => {
                state.loading = false;
                console.log("Error Details", action.error.message);
                state.error = action.payload;
            })
            .addCase(postAttachDocsReducer.fulfilled, (state, action) => {
                state.AttachDocs = action.payload;
            })
            .addCase(postAttachDocsReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postCardProfileLogoReducer.fulfilled, (state, action) => {
                state.cardProfileLogo = action.payload;
            }).addCase(postCardProfileLogoReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getFamilyCardReducer.fulfilled, (state, action) => {
                state.groupcard = action.payload;
            }).addCase(getFamilyCardReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
    }
});

export const { clearCardDataState, clearGroupcarddata } = cardSlice.actions;
export default cardSlice.reducer;